import { Trophy } from "lucide-react";

/**
 * Single notification row in the popover list.
 */
export default function NotificationItem({ n, onMarkRead }) {
  return (
    <li
      data-testid={`notification-${n.id}`}
      className={`px-3 py-2.5 rounded-xl cursor-pointer transition-all ${
        n.read
          ? "bg-slate-50 text-[#64748B]"
          : "bg-[#00E5FF]/10 text-[#0F172A] hover:bg-[#00E5FF]/15"
      }`}
      onClick={() => !n.read && onMarkRead(n.id)}
    >
      <div className="flex items-start gap-2.5">
        {n.kind === "milestone" && (
          <Trophy size={14} className="text-[#F5C542] mt-0.5 shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          <div className="text-xs font-semibold truncate">{n.title}</div>
          {n.body && (
            <div className="text-[11px] text-[#64748B] mt-0.5">{n.body}</div>
          )}
        </div>
        {!n.read && <div className="w-1.5 h-1.5 rounded-full bg-[#00E5FF] shrink-0 mt-1" />}
      </div>
    </li>
  );
}
